import {instance} from '../index';

export const offerApi = {
  getDiscountRequestsPaginatedList (pageNumber, rowsCount) {
    return instance.get(`/offers/discount-requests?page=${pageNumber}&size=${rowsCount}`)
  },
}
